import React from 'react';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import BackButton from 'components/BackButton';
import FormHeader from 'components/Form/Header';
import ActionsSection from 'components/Form/ActionsSection';
import { profileActions } from 'store/profile';
import { StyledBlock } from './StyledComponents';

const SECTION_NAME = 'PARENTAL_AGE';

const items = [
  { id: 0, name: 'Without limits' },
  { id: 6, name: '6+' },
  { id: 12, name: '12+' },
  { id: 16, name: '16+' },
  { id: 18, name: '18+' },
];

const AgePage = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const onEnter = (item) => {
    dispatch(profileActions.setPCLimit(item.id));
    history.goBack();
  };

  return (
    <>
      <BackButton onEnter={history.goBack} />
      <div>
        <FormHeader title="Age restrictions" description="Specify age restrictions" />
        <StyledBlock>
          <ActionsSection id={SECTION_NAME} sectionName={SECTION_NAME} defaultSection>
            {items.map((item) => (
              <ActionsSection.Button
                onEnter={() => onEnter(item)}
                key={item.id}
                label={item.name}
                focusOnMouseEnter
              />
            ))}
          </ActionsSection>
        </StyledBlock>
      </div>
    </>
  );
};

export default AgePage;
